module.exports = __webpack_public_path__ + "img/full0-min.ed9554a8.png";